import { Box, Card, CardContent } from '@mui/material';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import BulkVisitForm from '../../forms/BulkVisitForm';

const AddressBulkForm = ({
  selected,
  setSelected,
}: {
  selected: string[];
  setSelected: Dispatch<SetStateAction<string[]>>;
}) => {
  const [key, setKey] = useState(1);
  const closeForm = () => setSelected([]);
  useEffect(() => {
    setKey((prev) => prev + 1);
  }, [selected]);

  return (
    <Box
      sx={{
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
        position: 'sticky',
        width: '100%',
      }}
    >
      <Card
        sx={{
          minWidth: '250px',
          pointerEvents: 'initial',
        }}
      >
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1em',
          }}
        >
          Verwerk {selected.length} adres
          {selected.length > 1 && 'sen'}
          <BulkVisitForm defaultValues={{ addressIds: selected }} key={key} onClose={closeForm} />
        </CardContent>
      </Card>
    </Box>
  );
};

export default AddressBulkForm;
